import ReactLoading from "react-loading";

const FullPageLoader = () => {
    return (
        <div
            style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100vh",
                width: "100vw",
            }}
        >
            <ReactLoading type="spin" color="#000" height={50} width={50} />
        </div>
    );
};

export default FullPageLoader;